import { useQuery } from "@tanstack/react-query";
import { getMappingFilters } from "@/Common/api/meta/queries";

export function useMappingFilters(args: { enabled: boolean; provider: string; category: string }) {
	const { enabled, provider, category } = args;

	const {
		isLoading,
		error,
		data: mappingFiltersData,
	} = useQuery({
		enabled,
		queryKey: ["mappingFilters", provider, category],
		queryFn: async () => (await getMappingFilters({ provider, category, options: { sortBy: "name" } })) ?? [],
		staleTime: Infinity,
	});

	return {
		error,
		mappingFiltersData,
		isLoadingFilters: isLoading,
	};
}
